import React from 'react'
import styles from './Confirmation.module.css'
import { IoCloseSharp } from 'react-icons/io5'

export default function Confirmation({
    absolute = true,
    top = "",
    left = "",
    confirmation = "",
    title = "Вы уверены что хотите удалить",
    postTitle = "",
    color = '#000',
    acceptConfirmation = () => {},
    rejectConfirmation = () => {}    
}) {
  return (
    <div className={absolute ? styles.absolute : null}>
      <div className={styles.confirmation} style={absolute ? null : {position: "absolute", top : top, left : left}}>
      <div className={styles.textBlock} styles={{color: color}}>
        <div className={styles.title}>
          {title}
          <IoCloseSharp onClick={() => rejectConfirmation()}/>
        </div>
        <div className={styles.postTitle}>{postTitle}</div>
        {confirmation.text ? 
           <span> {confirmation.text}</span>
        :
        ""  
        }
        
      </div>
      <div className={styles.buttons}>
        <div className={styles.buttonDelete} onClick={() => acceptConfirmation(confirmation)}>Да, удалить</div>
        <div className={styles.buttonCancel} onClick={() => rejectConfirmation()}>Нет</div>
        </div> 
    </div>
    </div>
  )
}
